import styled from "styled-components";
import { NEAR_WHITE } from "../../config";

export const Container = styled.div<{ smaller: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${NEAR_WHITE};

  span {
    font-style: normal;
    font-weight: bold;
    font-size: ${(props) => (props.smaller ? "20px" : "24px")};
    line-height: 29px;
    margin-left: 8px;
  }

  .fa-circle-notch {
    animation-duration: 0.8s;
  }
`;
